module.exports = __webpack_public_path__ + "create_project.0ace9f49.webm";